export default {
    'name': 'pause-m',
    'width': '64',
    'height': '64',
    'viewBox': '0 0 64 64',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M14.9048 11H23.4762C24.5282 11 25.381 11.814 25.381 12.8182V49.1818C25.381 50.186 24.5282 51 23.4762 51H14.9048C13.8528 51 13 50.186 13 49.1818V12.8182C13 11.814 13.8528 11 14.9048 11ZM38.7143 11H47.2857C48.3377 11 49.1905 11.814 49.1905 12.8182V49.1818C49.1905 50.186 48.3377 51 47.2857 51H38.7143C37.6623 51 36.8095 50.186 36.8095 49.1818V12.8182C36.8095 11.814 37.6623 11 38.7143 11Z\' fill=\'#006CFD\'/>'
}
